import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { MsgModalListModel } from './Models/msg-modal-list.model';

@Component({
	selector: 'ion-ahs-dialogue',
	templateUrl: './ion-ahs-dialogue.component.html',
	styleUrls: ['./ion-ahs-dialogue.component.scss'],
	standalone: false
})
export class IonAhsDialogueComponent implements OnInit {
	// "value" passed in componentProps
	@Input() msModalData: MsgModalListModel[] = [];

	@Output() open = new EventEmitter<any>();

	constructor(private popoverController: PopoverController) {}

	ngOnInit() {}

	public okay($event) {
		//this.open.emit($event);
		this.popoverController.dismiss();
	}
}
